export class ErrorRefUnknown extends Error {}